import { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Download01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Layout } from "providers/Layout";
import { rentlyApi } from "api/rently";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { LockboxAccountsList } from "views/settings-integration/integrations/shared/LockboxAccountsList";
import { LockboxCredentialsTab } from "views/settings-integration/integrations/shared/LockboxCredentialsTab";
import { ImportLockboxesModal } from "views/settings-integration/integrations/shared/ImportLockboxesModal";

export const RentlyLockboxesView = () => {
  const queryClient = useQueryClient();
  const [importModalOpen, setImportModalOpen] = useState(false);

  const handleImportSuccess = useCallback(() => {
    setImportModalOpen(false);
    queryClient.invalidateQueries({ queryKey: ["LOCKBOXES"] });
  }, [queryClient]);

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.RENTLY_LOCKBOXES}
          name="Rently Lockboxes"
          path="/settings/integration/rently-lockboxes"
          actions={
            <Button
              variant={ButtonVariant.BASE}
              size={ButtonSize.SM}
              HugeIcon={Download01Icon}
              onClick={() => setImportModalOpen(true)}
            >
              Import lockboxes
            </Button>
          }
        />
      }
    >
      <LockboxCredentialsTab />
      <LockboxAccountsList vendor="rently" />
      <ImportLockboxesModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={handleImportSuccess}
        vendor="rently"
        emptyStateDescription="There are no lockboxes on this Rently account that we can import."
        noAccountsDescription="No Rently accounts connected. Connect an account before importing lockboxes."
        api={rentlyApi}
      />
    </Layout>
  );
};
